import { createI18n } from "vue-i18n";

const i18n = createI18n({ legacy: false, locale: "ru", messages: { ru: {} } });

export const withI18n = (application) => {
    application.use(i18n);
};
